import request from '@/utils/request'

// sso登陆
export function portalLogin(data) {
  return request({
    url: '/portal-sso/web/login',
    method: 'post',
    data
  })
}

// sso登出
export function portalLogout(data) {
  return request({
    url: '/portal-sso/web/logout',
    method: 'post',
    data
  })
}

// sso获取用户信息
export function portalProfile(data) {
  return request({
    url: '/portal-user/system/user/profile',
    method: 'get',
    data
  })
}
// 获取路由
export function getCurrentUserMenu() {
  return request({
    url: '/portal-user/getRouters?menuId=36&selfContained=true',
    method: 'get'
  })
}
// 修改密码
export function changPassword(data) {
  return request({
    url: '/portal-user/system/user/changePassword',
    method: 'PUT',
    data: data
  })
}

// 设备可用性检查
export function availableCheck(params) {
  return request({
    url: '/portal-user/system/pda/available-check',
    method: 'get',
    params
  })
}
// 获取登录限制配置信息
export function loginRestriction() {
  return request({
    url: '/portal-user/system/config/login-restriction',
    method: 'get'
  })
}

// 检查更新
export function checkAppUpdate(params) {
  return request({
    url: '/portal-user/system/app/vc/check-update',
    method: 'get',
    params
  })
}
